import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';

const PaginationComponent = ({ pageCount, currentPage, fetchData, feedbacks, setCurrentPage }) => {
	 useEffect(() => {
		 currentPage === 0 ? setCanPreviousPage(false) : setCanPreviousPage(true);
		 currentPage === pageCount - 1 ? setCanNextPage(true) : setCanNextPage(false);
		 window.scrollTo(0, 0);

	 	}, [pageCount, currentPage]);
		

	const [canPreviousPage, setCanPreviousPage] = useState(false);
	const [canNextPage, setCanNextPage] = useState(false);

	const gotoPage = (newPageNumber) => {
		fetchData({ pageIndex: newPageNumber });
		if(typeof setCurrentPage !== 'undefined'){
			setCurrentPage(newPageNumber);
		}
	};
	const previousPage = () => {
		currentPage > 0 && gotoPage(currentPage - 1);
		fetchData({ pageIndex: currentPage - 1 });
		if(typeof setCurrentPage !== 'undefined'){
			setCurrentPage(currentPage - 1);
		}
	}

	const nextPage = () => { 
		currentPage < pageCount - 1 && gotoPage(currentPage + 1); 
		fetchData({ pageIndex: currentPage + 1 });
		if(typeof setCurrentPage !== 'undefined'){
			setCurrentPage(currentPage + 1);
		}
	}

	return (
		<div className="pagination_box">
			{
				pageCount > 0 ? 
				<div className="pagination_buttons_box">
				<Button
					className="pagination_btn navigate_page first_page"
					onClick={() => gotoPage(0)}
					disabled={!canPreviousPage || feedbacks.length === 0}
				>
					{'<<'}
				</Button>
				<Button
					className="pagination_btn navigate_page prev_page"
					onClick={() => previousPage()}
					disabled={!canPreviousPage  || feedbacks.length === 0}
				>
					{'<'}
				</Button>
				{Array(pageCount).fill(0).map((numberPage, i) => (
					<Button
						key={'pagination' + i}
						className={'pagination_btn number_btn' + (currentPage === i ? ' select' : '')}
						onClick={() => gotoPage(i)}
						disabled={feedbacks.length === 0}
					>
						{i + 1}
					</Button>
				))}
				<Button
					className="pagination_btn navigate_page nex_page"
					onClick={() => nextPage()}
					disabled={!!canNextPage || feedbacks.length === 0}
				>
					{'>'}
				</Button>
				<Button
					className="pagination_btn navigate_page last_page"
					onClick={() => gotoPage(pageCount - 1)}
					disabled={!!canNextPage || feedbacks.length === 0}
				>
					{'>>'}
				</Button>
			</div> : null
			}
			
		</div>
	);
};

export default PaginationComponent;
